import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import trim from 'lodash/trim';

export const isNonEmptyString = (
  value
) => isString(value) && !isEmpty(trim(value));
